import React from 'react'
import { Box } from "@mui/material"

import { AppOfficesBlock } from "@components/DataBlocks/index"
import { AppButtonIcon } from "@components/@base"
import { officeModalData } from "@signals"


export default function AppOfficesBlockContainer({ rows }) {
	return <Box>
		<Box sx={{ display: "flex", alignItems: "start", justifyContent: "start", flexDirection: "column" }}>
			{rows?.map(({ name, type, country }, idx) => {
				if (idx < 10) {
					return <AppOfficesBlock
						name={name}
						type={type}
						country={country}
						key={`${name}-${idx}`}
					/>
				}
			})}
			{rows?.length >= 10 && <AppButtonIcon
				onClick={() => officeModalData.value = rows}
				iconWeight="regular"
				icon="plus"
				tooltip={`Show all`}
				sx={{ color: "info.main", pl: .2 }}
			/>}
		</Box>
	</Box>

}